module.exports = __webpack_public_path__ + "static/game1-d11fc8ec8d44c566cfce89072819d108.png";